/* ============================================================
   View Definitions
   ============================================================ */
export const VIEWS = {
    geopolitics: {
        label: "Geopolitics",
        icon: "🌍",
        feedCategories: [
            "politics",
            "middleeast",
            "asia",
            "africa",
            "europe",
            "defense",
            "gov",
        ],
        panelIds: ["liveNews", "earthquake", "market"],
    },
    finance: {
        label: "Finance",
        icon: "📈",
        feedCategories: ["finance"],
        panelIds: ["liveNews", "earthquake", "market"],
    },
    tech: {
        label: "Tech",
        icon: "💻",
        feedCategories: ["tech", "ai", "startups"],
        panelIds: ["liveNews", "earthquake", "market"],
    },
};
export const DEFAULT_VIEW = "geopolitics";
export const VIEW_IDS = ["geopolitics", "finance", "tech"];
